var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuggageLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 25",
    style: {
      enableBackground: "new 0 0 24 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000036931795618628533660000007969885846426562718_);}\n\t.st1{fill:none;stroke:#FFFFFE;stroke-width:0.75;}\n\t.st2{fill:#FFFFFE;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0.5,
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052787731594185084260000009659816403638863028_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000052787731594185084260000009659816403638863028_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.3,6.5H19c0.3,0,0.6,0.3,0.6,0.6v13.6c0,0.3-0.3,0.6-0.6,0.6H6.3c-0.3,0-0.6-0.3-0.6-0.6V7.1 C5.7,6.8,6,6.5,6.3,6.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.7,6.1V2.8c0-0.6,0.4-1,1-1h3.9c0.6,0,1,0.4,1,1v3.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.3,21.7c0,0.2,0,0.4,0.1,0.5c0.1,0.2,0.2,0.3,0.3,0.5C8.8,22.9,9,23,9.2,23.1c0.2,0.1,0.4,0.1,0.6,0.1 c0.2,0,0.4,0,0.6-0.1c0.2-0.1,0.3-0.2,0.5-0.3c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.2,0.1-0.4,0.1-0.5H9.7H8.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.1,21.7c0,0.2,0,0.4,0.1,0.5s0.2,0.3,0.3,0.5c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.4,0.1,0.6,0.1 c0.2,0,0.4,0,0.6-0.1c0.2-0.1,0.3-0.2,0.5-0.3c0.1-0.1,0.2-0.3,0.3-0.5c0.1-0.2,0.1-0.4,0.1-0.5h-1.5H14.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.1,10.4c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4H10.1z M9.4,17.5c0,0.2,0.2,0.4,0.4,0.4 c0.2,0,0.4-0.2,0.4-0.4H9.4z M9.4,10.4v7.1h0.8v-7.1H9.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13,10.4c0-0.2-0.2-0.4-0.4-0.4s-0.4,0.2-0.4,0.4H13z M12.3,17.5c0,0.2,0.2,0.4,0.4,0.4s0.4-0.2,0.4-0.4H12.3 z M12.3,10.4v7.1H13v-7.1H12.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16,10.4c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4H16z M15.2,17.5c0,0.2,0.2,0.4,0.4,0.4 c0.2,0,0.4-0.2,0.4-0.4H15.2z M15.2,10.4v7.1H16v-7.1H15.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuggageLight);
export default __webpack_public_path__ + "static/media/luggage-light.3d2fb6399638cc337af00d0f0c950692.svg";
export { ForwardRef as ReactComponent };